export default "__VITE_ASSET__CiojfU78__"